export enum EntranceType {
  /**
   * 观看
   */
  WATCH = 0,
  /**
   * 出价
   */
  BID = 1
}

export const EntranceTypeTextMap = {
  [EntranceType.WATCH]: '观看竞价',
  [EntranceType.BID]: '前往出价'
}
